import { COMPANY_ROLES, GLOBAL_ADMIN, EMPLOYEE } from 'garaje/utils/roles';
import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  roleName: () => faker.helpers.arrayElement(COMPANY_ROLES),
  confirmedAt: () => faker.date.past(),
  lastSeenAt: () => faker.date.past(),

  asGlobalAdmin: trait({
    roleName: GLOBAL_ADMIN,
  }),

  asEmployee: trait({
    roleName: EMPLOYEE,
  }),

  withUser: trait({
    afterCreate(companyRole, server) {
      companyRole.update({
        user: server.create('user', {
          fullName: 'John Doe',
          email: 'john@doe.com',
        }),
      });
    },
  }),
});
